// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1jrSR","imageUploader":"EGiftCard_imageUploader__3LsqJ"};